import * as React from 'react';
import { useState } from 'react';
import Typography from '@mui/material/Typography';
import { FlexCol, FlexRow } from '@app/modules/submenus/components/submenu-content-card/styles';
import { FontFamily } from '@atomic';
import { QuestionCard, Textarea } from './new-question-body.style';
export var NewQuestionBodyComponent = function (props) {
    var _a;
    var _b = useState(0), currentAnswerId = _b[0], setCurrentAnswerId = _b[1];
    var _c = useState(false), isOpcaoOutrosEscolhida = _c[0], setIsOpcaoOutrosEscolhida = _c[1];
    // novo estado para filtrar alternativas por title
    var _d = useState(''), filterText = _d[0], setFilterText = _d[1];
    var _e = useState(false), isFilterFocused = _e[0], setIsFilterFocused = _e[1];
    var handleOnSelectAlternative = function (id) {
        setIsOpcaoOutrosEscolhida(false);
        setCurrentAnswerId(id);
        props.onSelectAlternative(id);
    };
    var onSelectOpcaoOutros = function () {
        setIsOpcaoOutrosEscolhida(true);
        setCurrentAnswerId(0);
        props.onSelectAlternative(0);
    };
    var onOpcaoOutrosTextValueChange = function (e) {
        props.onOpcaoOutrosTextValueChange(e.currentTarget.value);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { marginBottom: 12 } },
            React.createElement("div", { style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    background: '#fff',
                    borderRadius: 12,
                    padding: '6px 10px',
                    border: "1px solid " + (isFilterFocused ? '#1677FF' : '#E6E9EE'),
                    boxShadow: isFilterFocused ? '0 6px 20px rgba(22,119,255,0.12)' : '0 1px 6px rgba(16,24,40,0.04)',
                    transition: 'box-shadow 160ms ease, border-color 160ms ease, transform 160ms',
                } },
                React.createElement("input", { type: "text", placeholder: "Filtrar op\u00E7\u00F5es...", value: filterText, onChange: function (e) { return setFilterText(e.currentTarget.value); }, onFocus: function () { return setIsFilterFocused(true); }, onBlur: function () { return setIsFilterFocused(false); }, style: {
                        width: '100%',
                        padding: '10px 8px',
                        borderRadius: 8,
                        border: 'none',
                        outline: 'none',
                        fontSize: 14,
                        color: '#222',
                        background: 'transparent',
                    } }))), (_a = props.alternatives) === null || _a === void 0 ? void 0 :
        _a.slice().filter(function (a) {
            return (filterText || '').trim() === '' ? true : a.title.toLowerCase().includes(filterText.trim().toLowerCase());
        }).sort(function (a, b) { return a.order - b.order; }).map(function (question) { return (React.createElement(QuestionCard, { active: question.id === currentAnswerId, key: question.id, onClick: function () {
                if (!props.disabled) {
                    handleOnSelectAlternative(question.id);
                }
            } },
            React.createElement("input", { type: "radio", value: question.id, checked: question.id === currentAnswerId }),
            React.createElement(Typography, { sx: { fontFamily: FontFamily.Inter400, fontSize: '14px' }, variant: "h5", component: "span" }, question.title))); }),
        props.alternatives &&
            props.alternatives.filter(function (a) {
                return (filterText || '').trim() === '' ? true : a.title.toLowerCase().includes(filterText.trim().toLowerCase());
            }).length === 0 && (React.createElement("div", { style: { textAlign: 'center', padding: '12px 0', color: '#666' } }, "Nenhuma alternativa encontrada.")),
        props.incluirOpcaoOutros && (React.createElement(React.Fragment, null,
            React.createElement(QuestionCard, { active: isOpcaoOutrosEscolhida, onClick: function () {
                    if (!props.disabled) {
                        onSelectOpcaoOutros();
                    }
                } },
                React.createElement(FlexCol, { style: { width: '100%', gap: '10px' } },
                    React.createElement(FlexRow, { style: { alignItems: 'center', gap: '16px' } },
                        React.createElement("input", { type: "radio", checked: isOpcaoOutrosEscolhida }),
                        React.createElement(Typography, { sx: { fontFamily: FontFamily.Inter400, fontSize: '14px' }, variant: "h5", component: "span" }, "Outro(a)")),
                    isOpcaoOutrosEscolhida && React.createElement(Textarea, { placeholder: "Descreva...", onChange: onOpcaoOutrosTextValueChange })))))));
};
